import * as PIXI from 'pixi.js';
import AssetsLoader from '../utils/assetsLoader';
import { RESOLUTION } from '../utils/commonUtils';
import CardContainer from './cardContainer';

export default class StageContainer extends PIXI.Container {
    constructor() {
        super();

        const stageFrameTexture = PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.STAGE_FRAME);
        const stageFrame = new PIXI.Sprite(stageFrameTexture);
        stageFrame.anchor.set(0.5, 1);
        stageFrame.x = -10*RESOLUTION;
        stageFrame.y = 0;
        this.addChild(stageFrame);
    }

    update(playerState, clientGameState) {
        this.getChildByLabel('stageCard')?.destroy({children: true});

        const stageCardInstance = playerState.field_stages[0];
        if (stageCardInstance) {
            const stageCard = new CardContainer(stageCardInstance);
            stageCard.label = 'stageCard';
            stageCard.x = 0;
            stageCard.y = -50*RESOLUTION;
            stageCard.scale.set(0.5);
            stageCard.hidePowerText();
            stageCard.hideCost();

            if (clientGameState?.selectableCards?.includes(stageCardInstance.instanceId)) {
                if (clientGameState.selectedCard === stageCardInstance.instanceId) {
                    stageCard.setHighlightSelected();
                } else {
                    stageCard.setHighlightSelectable();
                }
            }

            this.addChild(stageCard);
        }
    }
}
